import { z } from "zod";

export const ChecklistEntregaAmbienteCadastroSchema = z.object({
    idChecklistEntrega: z.number().int().optional(),
    ordem: z.coerce.string().nonempty({ message: "A ordem é obrigatória." }),
    descricao: z.string().nonempty({ message: "A descrição é obrigatória." }),
});

export type ChecklistEntregaAmbienteCadastroForm = z.infer<typeof ChecklistEntregaAmbienteCadastroSchema>;

export const defaultChecklistEntregaAmbienteCadastroForm: Partial<ChecklistEntregaAmbienteCadastroForm> = {
    idChecklistEntrega: undefined,
    ordem: '',
    descricao: '',

};
